module.exports = __webpack_public_path__ + "wxMicroService/img/bossCode.15ce3bdd.png";